import axios from "axios";
import { BASE_URL, DOMAIN } from "./apiConfig";

export const getLandingPageSettings = async () => {
  try {
    const CACHE_DURATION = 60 * 60 * 1000;

    const cachedData = localStorage.getItem("landingPageSettings");
    if (cachedData) {
      const parsed = JSON.parse(cachedData);
      const isExpired =
        Date.now() - parsed.timestamp > CACHE_DURATION;

      if (parsed.domain === DOMAIN && !isExpired) {
        return parsed.data;
      }
    }

    const response = await axios.get(
      `${BASE_URL}/landing-page-settings?domain_name=${DOMAIN}`
    );

    if (response.data.success) {
      const storeData = {
        domain: DOMAIN,
        data: response.data.data,
        timestamp: Date.now(),
      };

      localStorage.setItem("landingPageSettings", JSON.stringify(storeData));

      return response.data.data;
    }

    return null;
  } catch {
    return null;
  }
};
